import * as React from 'react'
import { Badge, IconButton } from '@mui/material'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
    iconButton: {
        color: '#fffffff2',
        padding: 4
    },
    icon: {
        fontSize: 26
    }
}))

export default function NotificationIcon({ count = 0 }) {
    const { classes } = useStyles()

    return (
        <IconButton className={classes.iconButton}>
            <Badge
                color="error"
                variant={count > 0 ? 'dot' : 'standard'}
                overlap="circular"
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <NotificationsNoneIcon className={classes.icon} />
            </Badge>
        </IconButton>
    )
}
